import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

interface MetricCardProps {
  title: string;
  value: string;
  change: string;
  positive: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, change, positive }) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
          {value}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Chip
            icon={positive ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
            label={change}
            size="small"
            color={positive ? "success" : "error"}
            sx={{ height: 24 }}
          />
          <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
            vs. last period
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MetricCard;
